import { getPaginationArgs, graphierQL } from 'utils'

import {
  GetWorkspacesQuery,
  GetWorkspacesQueryVariables
} from '~workspaces/types/__generated/gql/graphql'

export const getWorkspacesQuery = /*GraphQL */ `
query GetWorkspaces($limit: Int, $offset: Int, $mapFilter: MapFilterInput) {
  getWorkspaces(limit: $limit, offset: $offset, mapFilter: $mapFilter) {
    total
    items {
      id
      name
      description
      logo
      mapCollection {
        total
        items {
          id
          name
          isPublic
        }
      }
    }
  }
}    
`

export async function getWorkspaces(page: number, limit: number) {
  return graphierQL<GetWorkspacesQuery, GetWorkspacesQueryVariables>({
    query: getWorkspacesQuery,
    variables: {
      ...getPaginationArgs(page, limit, 1),
      mapFilter: {
        isPublic: true
      }
    }
  }).then((data) => data?.getWorkspaces)
}
